import { useEffect, useCallback, useRef } from "react";
import { Backdrop } from "@mui/material";
import { useLockedBody } from "usehooks-ts";
import "./style/SwipePopup.scss";
import { clsx } from "clsx";

interface ISwipePopupProps {
  onClose?: () => void;
  isOpen: boolean;
  children: React.ReactNode;
  [x: string]: any;
}

export const SwipePopup = ({ onClose, isOpen, children,...restProps }: ISwipePopupProps) => {
  const popupRef = useRef<HTMLInputElement>(null);

  const keyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    },
    [onClose, isOpen]
  );

  useLockedBody(isOpen, "root");

  useEffect(() => {
    document.addEventListener("keydown", keyPress);

    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  const closePopup = (e: React.MouseEvent) => {
    if (popupRef.current === e.target && onClose) {
      onClose();
    }
  };

  const classes = clsx(["SwipePopup", { "SwipePopup_isOpen": isOpen }]);

  return (
    <Backdrop
      open={isOpen}
      onClick={closePopup}
      ref={popupRef}
      sx={{
        zIndex: "var(--popupZ)"
      }}
      {...restProps}
    >
      <div className={classes}>
        <div className="SwipePopup-Swipe" onClick={onClose}></div>
        <div className="SwipePopup-Cnt">{children}</div>
      </div>
    </Backdrop>
  );
};
